// extracted by css-extract-rspack-plugin
export default {"root":"root-tk8FA5","content":"content-az3SkK flex justify-between items-center","consultationBookedTime":"consultationBookedTime-BWW0At text-body-label"};